var map = {
	"./icon-status-00.svg": "3e3e",
	"./icon-status-01.svg": "df78",
	"./icon-status-02.svg": "20f6",
	"./icon-status-04.svg": "e3c2",
	"./icon-status-06.svg": "3a06",
	"./icon-status-08.svg": "10c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a363";